import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationDetoxificationIntermediaryDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const gpx1 = getGenePalette(geneColors.GPX1);
  const sod2 = getGenePalette(geneColors.SOD2);
  const nqo1 = getGenePalette(geneColors.NQO1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18382_42417)">
        <rect width={1024} height={636} transform="translate(0 170)" fill="white" />
        <g id="detoxification-diagram">
          <rect width={1024} height={636} transform="translate(0 170)" fill="white" />
          <g id="background">
            <rect width={912} height={492} transform="translate(53 233)" fill="#FFF1F2" />
            <g id="Report titles">
              <text
                id="25-Hydroxy Vitamin D"
                fill="#282828"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={24}
                letterSpacing="0em"
              >
                <tspan x={69.9609} y={270.16}>
                  Liver
                </tspan>
              </text>
            </g>
            <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
              <g id="gene-lozenge_5">
                <path
                  d="M387 387.5C387 385.291 388.791 383.5 391 383.5H483C485.209 383.5 487 385.291 487 387.5V415.5C487 417.709 485.209 419.5 483 419.5H391C388.791 419.5 387 417.709 387 415.5V387.5Z"
                  fill={gpx1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={418.656} y={406.948}>
                    GPX1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="gpx1"
                groupId="gene-snps"
                genePalette={gpx1}
                startX={395}
                startY={421.5}
                snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-SOD2" {...geneGroupProps("SOD2", onGeneClick)}>
              <g id="gene-lozenge_6">
                <path
                  d="M447 442.5C447 440.291 448.791 438.5 451 438.5H543C545.209 438.5 547 440.291 547 442.5V470.5C547 472.709 545.209 474.5 543 474.5H451C448.791 474.5 447 472.709 447 470.5V442.5Z"
                  fill={sod2.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_2"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={476.211} y={461.948}>
                    SOD2
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="sod2"
                groupId="gene-snps_2"
                genePalette={sod2}
                startX={455}
                startY={476.5}
                snpCount={getGeneSnpCount("SOD2", expectedSnps, geneColors)}
              />
            </g>
            <g id="gene-NQO1" {...geneGroupProps("NQO1", onGeneClick)}>
              <g id="gene-lozenge_7">
                <path
                  d="M503 387.5C503 385.291 504.791 383.5 507 383.5H599C601.209 383.5 603 385.291 603 387.5V415.5C603 417.709 601.209 419.5 599 419.5H507C504.791 419.5 503 417.709 503 415.5V387.5Z"
                  fill={nqo1.lozengeFill}
                />
                <text
                  id="gene-lozenge-label_3"
                  fill="black"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={16}
                  letterSpacing="0em"
                >
                  <tspan x={531.969} y={406.948}>
                    NQO1
                  </tspan>
                </text>
              </g>
              <GeneSnpShapes
                id="nqo1"
                groupId="gene-snps_3"
                genePalette={nqo1}
                startX={511}
                startY={421.5}
                snpCount={getGeneSnpCount("NQO1", expectedSnps, geneColors)}
              />
            </g>
            <g id="Report titles_2">
              <text
                id="25-Hydroxy Vitamin D_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={443.03} y={317.12}>
                  Intermediary{" "}
                </tspan>
                <tspan x={403.233} y={345.12}>
                  Antioxidant Protection
                </tspan>
              </text>
            </g>
            <g id="Frame 468">
              <rect
                x={427.7}
                y={564.2}
                width={134.6}
                height={102.6}
                stroke="#282828"
                strokeWidth={1.4}
              />
              <g id="Rich Text Block">
                <text
                  id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                  fill="#1A1A1A"
                  style={{ whiteSpace: "pre" }}
                  xmlSpace="preserve"
                  fontFamily="Gilroy W05 Medium"
                  fontSize={14}
                  letterSpacing="0em"
                >
                  <tspan x={461.982} y={608.267}>
                    Activated{" "}
                  </tspan>
                  <tspan x={450.676} y={632.267}>
                    intermediates
                  </tspan>
                </text>
              </g>
            </g>
            <g id="lines">
              <path
                id="Vector"
                d="M434.658 436.7L434.658 436L433.258 436L433.258 436.7L433.958 436.7L434.658 436.7ZM433.958 553L438 546L429.917 546L433.958 553ZM433.958 436.7L433.258 436.7L433.258 546.7L433.958 546.7L434.658 546.7L434.658 436.7L433.958 436.7Z"
                fill="#1A1A1A"
              />
            </g>
            <g id="lines_2">
              <path
                id="Vector_2"
                d="M559.658 437.7L559.658 437L558.258 437L558.258 437.7L558.958 437.7L559.658 437.7ZM558.958 554L563 547L554.917 547L558.958 554ZM558.958 437.7L558.258 437.7L558.258 547.7L558.958 547.7L559.658 547.7L559.658 437.7L558.958 437.7Z"
                fill="#1A1A1A"
              />
            </g>
            <g id="lines_3">
              <path
                id="Vector_3"
                d="M499.658 484.7L499.658 484L498.258 484L498.258 484.7L498.958 484.7L499.658 484.7ZM498.958 554L503 547L494.917 547L498.958 554ZM498.958 484.7L498.258 484.7L498.258 547.7L498.958 547.7L499.658 547.7L499.658 484.7L498.958 484.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationDetoxificationIntermediaryDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={636}
    viewBox="0 170 1024 636"
    fill="none"
    {...props}
  >
    <MethylationDetoxificationIntermediaryDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18382_42417">
        <rect width={1024} height={806} fill="white" />
      </clipPath>
      <clipPath id="clip1_18382_42417">
        <rect width={1024} height={636} fill="white" transform="translate(0 170)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationDetoxificationIntermediaryDiagram;
